<template>
  <el-dialog title="修改记录" :visible.sync="visible" width="1000px" @close="handleClose">
    <h3>当前数据</h3>
    <el-table :data="currentData" border style="width: 100%">
      <el-table-column prop="branchNames" label="分公司" show-overflow-tooltip></el-table-column>
      <el-table-column prop="orgNames" label="T3" show-overflow-tooltip></el-table-column>
      <el-table-column prop="areaNames" label="T4" show-overflow-tooltip></el-table-column>
      <el-table-column prop="agentName" label="姓名"></el-table-column>
      <el-table-column prop="agentCode" label="PE号码"></el-table-column>
      <el-table-column prop="roles" label="用户角色" show-overflow-tooltip></el-table-column>
      <el-table-column prop="enableStatus" label="状态"></el-table-column>
      <el-table-column prop="operator" label="创建人"> </el-table-column>
      <el-table-column prop="createDate" label="修改时间"> </el-table-column>
      <el-table-column prop="timeRange" label="时间范围"> </el-table-column>
    </el-table>
    <h3>历史数据</h3>
    <el-table :data="historyData" border style="width: 100%">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="branchNames" label="分公司" show-overflow-tooltip></el-table-column>
      <el-table-column prop="orgNames" label="T3" show-overflow-tooltip></el-table-column>
      <el-table-column prop="areaNames" label="T4" show-overflow-tooltip></el-table-column>
      <el-table-column prop="agentName" label="姓名"></el-table-column>
      <el-table-column prop="agentCode" label="PE号码"></el-table-column>
      <el-table-column prop="roles" label="用户角色" show-overflow-tooltip></el-table-column>
      <el-table-column prop="enable" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.enable">启用</span>
          <span v-else>禁用</span>
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="创建人"> </el-table-column>
      <el-table-column prop="createDate" label="修改时间"> </el-table-column>
      <el-table-column prop="timeRange" label="时间范围"> </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: true, // 控制对话框的显示与隐藏
      // demo数据
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1516 弄",
        },
      ],
    };
  },
  props: {
    currentData: {
      type: Array,
      default: [],
    },
    historyData: {
      type: Array,
      default: [],
    },
  },
  watch:{
    // 'currentData': function (val) {
    //   if(val.id) {
    //     console.log(val,'currentData===========')
    //   }
    // }
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>
  
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/recruit/userManagement/component/modifyRecordDialog.vue